import {getDate} from '../../../../../../@casino/lib/getDate';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';

const useStyles = makeStyles(() => ({
    root: {
        width: 'calc(100% - 40px)',     
        background: '#1b2039',
        borderRadius: '8px',
        padding: 20,
        marginTop: 12,
        marginBottom: 20
    },
    search: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        borderRadius: 4,
        color: '#fff',
        outline: 'none',
        margin: '10px 0',
        width: '97.3%'
    },
    colorFFF: {
        color: '#fff',
    },
    divider: {
        height: 1, background: 'rgb(176, 176, 176)', marginTop: 12
    },
    wrapSwitch: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165,
    },
    manually: {
        display: 'flex', alignItems: 'center', width: 165, color: '#fff'
    },
    spo: {
        width: 40, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: '#141b33',
        color: '#fff',
        boxShadow: '4px 4px 8px 0px rgb(34 60 80 / 20%)',
    },
    datetime: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff'
    },
    text: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff',
        height: 36,
        width: 149
    },
}));


const rowsHistory = (history) => {
    return  history.map((item) => {
        return {
            id: item.id,
            login: item.login,
            date_event: getDate(+item.date_event),
            amount: new Intl.NumberFormat('ru-RU').format(item.amount) + '₽',
            action: item.action,
            balance_after: new Intl.NumberFormat('ru-RU').format(item.balance_after) + '₽',
            balance_before: new Intl.NumberFormat('ru-RU').format(item.balance_before) + '₽',
            game_name: <span style={{textTransform: 'capitalize'}}>{item.game_name}</span>,
            client_transaction: item.client_transaction_id,
        }
    })
} 

const columns = [
    { id: 'id', label: 'ID'},
    { id: 'login', label: 'Логин'},
    { id: 'date_event', label: 'Дата'},
    { id: 'amount', label: 'Сумма'},
    { id: 'action', label: 'Событие'},
    { id: 'balance_before', label: 'Баланс до'},
    { id: 'balance_after', label: 'Баланс после'},
    { id: 'game_name', label: 'Название игры'},
    { id: 'client_transaction', label: 'Транзакция'}
]

export {
    rowsHistory, 
    columns,
    useStyles
}